import React, { useEffect, useState } from "react";
import "./Toast.scss";
import Icon from "@mdi/react";
import { mdiAlertCircle } from "@mdi/js";
// import checkadded from "../../../assets/icons/Check.svg";

const ErrorToast = ({ title, message, autoHideDuration, toastKey }) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen(true);
    const data = setTimeout(() => {
      setOpen(false);
    }, 4000);
    return () => {
      clearTimeout(data);
    };
  }, [toastKey]);

  return (
    <div
      className={`toast-container position-fixed end-0 ${
        open ? "toast-open-animation" : "toast-close-animation"
      }`}
    >
      <div
        className={`toast align-items-center bg-red text-white border-0 p-2 justify-content-between ${
          open ? "show" : "hide"
        }`}
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
        // style={{ backgroundColor: "red" }}
      >
        <div className="d-flex justify-content-between">
          <div className=" d-flex gap-2 p-2 align-items-center ">
            <Icon path={mdiAlertCircle} size={0.8} />
            <strong className="me-auto fs-6">{title}</strong>
          </div>
          <button
            type="button"
            className="btn-close text-blue me-2 m-auto"
            data-bs-dismiss="toast"
            aria-label="Close"
          />
        </div>
        {message && <div className="toast-body">{message}</div>}
      </div>
    </div>
  );
};

export default ErrorToast;
